<style>
  iframe {
    border-width: 0px;
    height: 600px;
    width: 100%;
  }
  p {
    padding: 2rem;
    /* border: rgba(80, 1, 1, 0.76) 2px solid; */
    margin: 2rem;
  }
</style>
<script>
	import { Col, Container, Row } from "sveltestrap";
  import {getToken} from "../js-core/conn/auth/auth-main"
  let errMsg, bstickReached, isLoading
  const token = getToken()
  async function openSetup() {
    const win = window.open(`http://192.168.0.1:8080/setup.html?token=${token}`, '_blank');
    win.focus();
  }
  async function startSetup() {
    bstickReached = true
    // const retryMax = 5
    // isLoading = true
    // for (var i = 0; i < retryMax; i++) {
    //   if (await bstickReachable()) break
    // }
    // if (i === retryMax) {
    //   errMsg = "Brite Stick not reachable" 
    //   return
    // }
    // isLoading = false
    // bstickReached = true
  }
  async function bstickReachable() {
    try {
      const res = await fetch(`http://192.168.0.1:8080/setup.html?token={token}`, {
        mode: "cors",
        cache: "no-cache",
        redirect: "error",
        headers: {
          "Upgrade-Insecure-Requests": 0
        }
      })
      return res.status === 200
    } catch (e) {
      return false
    }
  }
</script>
<div class="wrapper">
  <div class="start-instructions">
    <p>
      Make sure that your device is powered on and plugged into the HDMI port.
      Then, wait until the Screen asks you to go to this page.
      <br><br>
      Once the Screen asks for this page, please connect this device to the WiFi Network shown on the screen.
      The password is also shown on the Screen.
      Once successfully connected to the Screen's network, please press "I'm connected to the Screen's Network" 
      <br><br>
      <button class="normal" on:click={() => openSetup()}>I'm connected to the Screen's Network</button>
    </p>
  </div>
  {#if bstickReached}
    <iframe class="from-server" title="Brite Stick Setup" src="http://192.168.0.1:8080/setup.html?token={token}" />
  {:else if errMsg}
    <p>{errMsg}</p>
  {:else if isLoading}
    <p>Loading Brite Signal...</p>
  {/if}
</div>
